import ButtonUI from './ButtonUI';
import { useTheme } from '@mui/material/styles';

const FormHeaderUI = ({
  addClick,
  modClick,
  deleteClick,
  copyClick,
  addDisabled,
  modDisabled,
  deleteDisabled,
  copyDisabled,
  ...props
}) => {
  const theme = useTheme();
  const ui = theme.palette.ui;

  return (
    <>
      <div className="flex gap-2 p-3 flex-wrap">
        {addClick && (
          <ButtonUI
            className="py-3"
            style={{ background: ui.addButton }}
            text="Hozzáadás"
            size="sm"
            disabled={addDisabled}
            onClick={addClick}
          />
        )}
        {modClick && (
          <ButtonUI
            className="bg-warning py-3"
            text="Szerkesztés"
            size="sm"
            disabled={modDisabled}
            onClick={modClick}
          />
        )}
        {deleteClick && (
          <ButtonUI
            className="bg-danger py-3"
            text="Törlés"
            size="sm"
            disabled={deleteDisabled}
            onClick={deleteClick}
          />
        )}
        {copyClick && (
          <ButtonUI
            className="py-3"
            style={{ background: ui.primaryButton }}
            text="Másolás"
            size="sm"
            disabled={copyDisabled}
            onClick={copyClick}
          />
        )}
      </div>
    </>
  );
};

export default FormHeaderUI;
